interface HeaderConfig {
  field: string;
  label: string;
  sortable: boolean;
  parentClassName: string;
  alignment?: "left" | "center";
}

export const headerConfig: HeaderConfig[] = [
  {
    field: "suppliers",
    label: "Tedarikçiler",
    sortable: false,
    parentClassName: "flex items-center pr-4 ml-[-8px] h-[40px] pl-[53px]",
    alignment: "left",
  },
  {
    field: "completed",
    label: "Tamamlanan",
    sortable: false,
    parentClassName: "flex items-center h-[40px]",
    alignment: "center",
  },
  {
    field: "comment",
    label: "Yorum",
    sortable: false,
    parentClassName: "flex items-center h-[40px] justify-center ",
    alignment: "center",
  },
  {
    field: "duration",
    label: "Harcanan Süre",
    sortable: false,
    parentClassName: "flex items-center h-[40px] justify-center ",
    alignment: "center",
  },
  {
    field: "lastActivity",
    label: "Son Hareket",
    sortable: false,
    parentClassName: "flex items-center h-[40px] justify-center ",
    alignment: "center",
  },
  {
    field: "status",
    label: "Durum",
    sortable: false,
    parentClassName: "flex items-center h-[40px] justify-center ",
    alignment: "center",
  },
];
